import { useMemo } from 'react';
import { sanitizeHtml } from '~/lib/markdown.js';
import { cn } from '~/lib/cn.js';

/**
 * Renders server-sanitised HTML, sanitising it a second time in the browser.
 * This is the only place in the app that sets HTML directly.
 */
export function Prose({ html, className }: { html: string; className?: string }) {
  const safe = useMemo(() => sanitizeHtml(html), [html]);
  return <div className={cn('prose-editorial', className)} dangerouslySetInnerHTML={{ __html: safe }} />;
}
